module.exports = __webpack_public_path__ + "static/media/diocese-logo.483f8d17.svg";